const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};

['load', 'resize'].forEach((event) => {
    window.addEventListener(event, () => {
        appHeight();
    });
});
